import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import styled from 'styled-components';
import { openModal } from 'actions/modal';

import { Text, Separator, Row, Col, Button } from '@cuemath/comps';
import MODAL from 'constants/modal';

import {
  Head,
  Message,
  FormWrapper,
  FieldWrapper,
  renderFormField,
  ButtonWrapper,
} from 'modules/form';
import { parentFields, getOnChangeMethod, getInputChangeMethod } from 'constants/form';
import { LinkButton } from 'modules/list';
import { FORM_ACTIONS, MODAL_FORM } from 'constants/form';

const RowWrapper = styled(Row)`
  width: 80%;
`;

const ColWrapper = styled(Col)`
  width: 25%;
`;

const TextWrapper = styled(Text)`
  font-weight: 600;
`;

class ParentContainer extends PureComponent {
  static defaultProps = {
    parent: null,
  };

  static propTypes = {
    parent: PropTypes.object,
    students: PropTypes.object,
    actions: PropTypes.shape({
      openModal: PropTypes.func.isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    const { parent } = this.props;
    this.state = {
      errorText: null,
      message: null,
      form: this.getFormDefaults(),
      parentData: parent,
      formFields: this.getFormFields(),
    };
    parentFields.forEach(field => {
      const methodName = getOnChangeMethod(field.name);
      this[methodName] = this.onChange.bind(this, field.name);
    });
  }

  getFormDefaults = () => {
    const { parent } = this.props;
    const formDefaults = {};

    parentFields.forEach(field => {
      formDefaults[field.name] =
        !!parent && parent[field.param] ? parent[field.param] : field.default;
    });
    return formDefaults;
  };

  getFormFields = () => {
    return parentFields.map(field => {
      return field;
    });
  };

  onChange = (key, value) => {
    const { form, errorText } = this.state;
    const newForm = { ...form };

    newForm[key] = value;

    const stateChanges = { form: newForm };
    if (errorText) stateChanges.errorText = null;

    this.setState(() => ({ ...stateChanges }));
  };

  onToggle = event => {
    const { form, errorText } = this.state;
    const key = event.target.name;
    const value = event.target.checked;
    const stateChanges = {
      form: {
        ...form,
        [key]: value,
      },
    };
    if (errorText) stateChanges.errorText = null;
    this.setState(() => ({ ...stateChanges }));
  };

  onOptionChange = (key, value) => {
    const { form, errorText } = this.state;
    const stateChanges = {
      form: {
        ...form,
        [key]: value,
      },
    };
    if (errorText) stateChanges.errorText = null;
    this.setState(() => ({ ...stateChanges }));
  };

  generateStudentData = student => {
    const { parentData } = this.state;
    const updatedStudent = {
      ...student,
      email: parentData.email ? parentData.email : null,
      parent_name: `${parentData.first_name}  ${parentData.last_name}`,
      phone: parentData.phone,
      country_code: parentData.country_code ? parentData.country_code : '91',
    };
    return updatedStudent;
  };

  addStudent = e => {
    e.preventDefault();
    const { actions } = this.props;

    const studentDetails = this.generateStudentData({});
    actions.openModal(
      MODAL_FORM.STUDENT,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
        height: MODAL.HEIGHT,
      },
      { formType: FORM_ACTIONS.CREATE, data: studentDetails },
    );
  };

  onContinue = student => {
    const { actions } = this.props;
    const studentDetails = this.generateStudentData(student);

    actions.openModal(
      MODAL_FORM.STUDENT,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
        height: MODAL.HEIGHT,
      },
      { formType: FORM_ACTIONS.CREATE, data: studentDetails },
    );
  };

  renderFormHeader = userType => {
    return (
      <Head>
        <Text size="xlarge" align="center">
          {`${userType} DETAILS`}
        </Text>
      </Head>
    );
  };

  renderStudents = () => {
    const { students } = this.props;
    if (students && Array.isArray(students) && students.length > 0) {
      return (
        <React.Fragment>
          {students.map(student => {
            return (
              <React.Fragment>
                <RowWrapper>
                  <ColWrapper>
                    <Text>{student.first_name}</Text>
                  </ColWrapper>
                  <ColWrapper>
                    <Text>{student.last_name}</Text>
                  </ColWrapper>
                  <ColWrapper>
                    <Text>{student.grade}</Text>
                  </ColWrapper>
                  <ColWrapper>
                    {student && !student.intel_enrollment_id ? (
                      <LinkButton
                        text="Continue.."
                        onClick={() => this.onContinue(student)}
                      />
                    ) : (
                      <LinkButton text="Enrolled" />
                    )}
                  </ColWrapper>
                </RowWrapper>
              </React.Fragment>
            );
          })}
        </React.Fragment>
      );
    }
    return <Text>'No Students Registered'</Text>;
  };

  renderStudentsHeader = () => {
    const { students } = this.props;
    if (students && Array.isArray(students) && students.length > 0) {
      return (
        <React.Fragment>
          <RowWrapper>
            <ColWrapper>
              <TextWrapper>{'First Name'}</TextWrapper>
            </ColWrapper>
            <ColWrapper>
              <TextWrapper>{'Last Name'}</TextWrapper>
            </ColWrapper>
            <ColWrapper>
              <TextWrapper>{'Grade'}</TextWrapper>
            </ColWrapper>
          </RowWrapper>
        </React.Fragment>
      );
    }
  };

  renderFormFields = () => {
    const { formFields, form } = this.state;

    return (
      <FieldWrapper>
        {formFields.map(field => {
          const required = field.required;
          const placeholder = field.label;
          const disabled = !field.editable;

          return renderFormField({
            ...field,
            value: form[field.name],
            onChange: this[getInputChangeMethod(field)],
            required,
            placeholder,
            disabled,
          });
        })}
      </FieldWrapper>
    );
  };

  renderFooter = () => {
    return (
      <ButtonWrapper>
        <Button label="Add Student" onClick={this.addStudent} />
      </ButtonWrapper>
    );
  };

  render() {
    const { message } = this.props;
    const { errorText } = this.state;

    return (
      <form onSubmit={this.onSubmit}>
        <FormWrapper>
          {errorText && <Message error={true}>{errorText}</Message>}
          {this.renderFormHeader('PARENT')}
          {message && <Message>{message}</Message>}
          <Separator transparent height="25" />
          {this.renderFormFields()}
          <Separator transparent height="25" />
          {this.renderFormHeader('STUDENTS')}
          <Separator transparent height="30" />
          {this.renderStudentsHeader()}
          <Separator transparent height="10" />
          {this.renderStudents()}
          <Separator transparent height="50" />
          {this.renderFooter()}
        </FormWrapper>
      </form>
    );
  }
}

export default connect(null, dispatch => ({
  actions: bindActionCreators({ openModal }, dispatch),
}))(ParentContainer);
